module.exports = __webpack_public_path__ + "img/phone.b43a8d56.svg";